import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { SpinnerService } from '../components/spinner-load/spinner.service';
import { environment } from 'src/environments/environment';

/**
 * Interceptor per lo spinner di caricamento
 */
@Injectable({
  providedIn: 'root'
})
export class SpinnerInterceptor implements HttpInterceptor {

  // contatore delle chiamate ancora in volo (sostituisce l'array per gestire correttamente URL duplicati)
  private pendingRequests = 0;

  // servizi che non devono mostrare lo spinner
  private spinnerCallExceptions: string[] = ['report/SSO'];

  constructor(private spinner: SpinnerService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const ignored =
      (request.url.includes(environment.keycloak.url) && request.url.includes('/openid-connect/token')) ||
      request.url.includes('consultazionemassiva') || (request.url.includes('downloadRequest') && request.method === "GET");

    const tracked =
      !ignored &&
      this.spinnerCallExceptions.every(service => !request.url.includes(service));

    if (tracked) {
      this.pendingRequests++;
      if (this.pendingRequests === 1) {
        this.spinner.show();
      }
    }

    return next.handle(request).pipe(
      catchError((err) => throwError(err)),
      finalize(() => {
        if (tracked) {
          this.pendingRequests--;
          if (this.pendingRequests === 0) {
            this.spinner.hide();
          }
        }
      })
    );
  }
}
